import { render, staticRenderFns } from "./CustomerRouter.vue?vue&type=template&id=56e5a178&scoped=true"
import script from "./CustomerRouter.vue?vue&type=script&lang=js"
export * from "./CustomerRouter.vue?vue&type=script&lang=js"
import style0 from "./CustomerRouter.vue?vue&type=style&index=0&id=56e5a178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5a178",
  null
  
)

export default component.exports